import { CourseDaysLesson, StepActivity, Lesson, LiveLesson, UserCustomWorkout } from '.';
const TASKS_COUNT = 4;
const TASKS_COUNT_WITHOUT_STEPS = 3;
export const MEAL_TASK_REMIND_AT_DEFAULT = '19:50';
export const TASK_DATE_QUERY = 'date';
export const TASK_LESSON_HISTORY_QUERY = 'lesson_history_calendar';
export class Task {
    constructor(data) {
        Object.defineProperty(this, "goal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "current", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isComplete", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.goal = data.goal;
        this.current = data.current;
        this.isComplete = data.isComplete;
    }
    static sampleWorkout() {
        return new Task({ goal: 200, current: 200, isComplete: true });
    }
    static sampleSteps() {
        return new Task({ goal: 5000, current: 1235, isComplete: false });
    }
    static sampleWeight() {
        return new Task({ goal: 0, current: 55, isComplete: false });
    }
}
Object.defineProperty(Task, "roundTaskCalories", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: Math.round
});
export class MealTask {
    constructor(data) {
        Object.defineProperty(this, "currentTotalCal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "referenceCalMin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isComplete", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasEatenBreakfast", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasEatenLunch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasEatenDinner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasEatenSnacking", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.currentTotalCal = data.currentTotalCal;
        this.referenceCalMin = data.referenceCalMin;
        this.isComplete = data.isComplete;
        this.hasEatenBreakfast = data.hasEatenBreakfast;
        this.hasEatenLunch = data.hasEatenLunch;
        this.hasEatenDinner = data.hasEatenDinner;
        this.hasEatenSnacking = data.hasEatenSnacking;
    }
    static sample() {
        return new MealTask({
            currentTotalCal: 485,
            referenceCalMin: 1609,
            isComplete: false,
            hasEatenBreakfast: true,
            hasEatenLunch: true,
            hasEatenDinner: false,
            hasEatenSnacking: false,
        });
    }
    get eatenMealsCount() {
        return +this.hasEatenBreakfast + +this.hasEatenLunch + +this.hasEatenDinner + +this.hasEatenSnacking;
    }
}
export class TaskLesson {
    constructor(data, config) {
        Object.defineProperty(this, "spentCalories", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "durationSeconds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lesson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "liveLesson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.spentCalories = data.spentCalories;
        this.durationSeconds = data.durationSeconds;
        this.lesson = data.lesson ? new Lesson(data.lesson, config) : null;
        this.liveLesson = data.liveLesson ? new LiveLesson(data.liveLesson, config) : null;
    }
    get durationMinutes() {
        return Math.floor(this.durationSeconds / 60);
    }
}
export class DailyWorkoutTask {
    constructor(data, config) {
        Object.defineProperty(this, "workout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userCustomWorkouts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "courseDaysLessons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "completedLessons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stepActivity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.workout = new Task(data.workout);
        this.userCustomWorkouts = data.userCustomWorkouts.map((v) => new UserCustomWorkout(v, config));
        this.courseDaysLessons = data.courseDaysLessons.map((v) => new CourseDaysLesson(v, config));
        this.completedLessons = data.completedLessons.map((v) => new TaskLesson(v, config));
        this.stepActivity = data.stepActivity ? new StepActivity(data.stepActivity) : null;
    }
}
export class DailyStepsTask {
    constructor(data) {
        Object.defineProperty(this, "steps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stepActivity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.steps = new Task(data.steps);
        this.stepActivity = data.stepActivity ? new StepActivity(data.stepActivity) : null;
    }
}
export class DailyTasks {
    constructor(data) {
        Object.defineProperty(this, "meal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "workout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "steps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "weight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stepsSynced", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isGoalsSet", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "needsRediagnosis", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.meal = new MealTask(data.meal);
        this.workout = new Task(data.workout);
        this.steps = new Task(data.steps);
        this.weight = new Task(data.weight);
        this.stepsSynced = data.stepsSynced;
        this.isGoalsSet = data.isGoalsSet;
        this.needsRediagnosis = data.needsRediagnosis;
    }
    get completedTasksCount() {
        return +this.meal.isComplete + +this.workout.isComplete + +this.steps.isComplete + +this.weight.isComplete;
    }
    get totalTasksCount() {
        return this.stepsSynced ? TASKS_COUNT : TASKS_COUNT_WITHOUT_STEPS;
    }
    static sampleDailyTasks() {
        return new DailyTasks({
            meal: MealTask.sample(),
            workout: Task.sampleWorkout(),
            steps: Task.sampleSteps(),
            weight: Task.sampleWeight(),
            stepsSynced: true,
        });
    }
}
